import cookie from '@boiseitguru/cookie-cutter';

export default function setCookie(name, value, duration?) {
  const isBrowser = typeof window !== 'undefined';

  if (!isBrowser) return;

  // Create cookie expiration time
  const currentTime = new Date();
  const cookieExpires = new Date(
    currentTime.setHours(currentTime.getHours() + (duration ? duration : 6))
  ); // set cookie expires at +6hours

  cookie.set(name, value, { path: '/', expires: cookieExpires });

  return;
}
